import React from 'react';

const Loading = () => {
    return (
        <div className="loading-wrapper">
            <div className="loadingio-eclipse">
                <div className="ldio-rpinwye8j0b">
                    <div></div>
                </div>
            </div>
        </div>
    );
};

export default Loading;
